export default "__VITE_ASSET__04056b71__"